var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect, useMemo } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Pane, Button, Row, Col, PaneFooter, AccordionSet, Accordion, ErrorModal, Modal, RadioButton, ConfirmationModal, MessageBanner, Loading, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { Controller } from "react-hook-form";
import { navigation } from "../../components/navigation";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { useModal, useSuccessModal } from "../../utils/useModal";
import { getActiveRegistrations, getActiveRegistrationForAgency, } from "../../utils/publisherRegistrationUtils";
import { useAccordion } from "../../utils/useAccordion";
import { getAgencyLabelMessageId } from "../../utils/getAgencyLabelMessageId";
import { getAssignBlockedReasonMessageId } from "../../utils/productNumberAssignErrors";
import { usePermissions } from "../../hooks/usePermissions";
import { RecekTextField, RecekSelection } from "../../components/inputs";
import { useProductNumberAssignData } from "../../hooks/useProductNumberAssignData";
import { useProductNumberAssignForm } from "../../hooks/useProductNumberAssignForm";
import { useProductNumberAssignActions } from "../../hooks/useProductNumberAssignActions";
import { useProductNumberAssignOptions } from "../../hooks/useProductNumberAssignOptions";
import { filterUsablePublisherPrefixes, getAllowedMagnitudeOptions, isNewPrefixNeeded, resolveNewPrefixChoiceMessageIds, resolvePreviewNoNumberNoticeMessageId, resolveSelectionNoticeMessageId, offersOnlySmallestMagnitude, resolveEffectiveMagnitude, } from "../../utils/newPrefixMagnitude";
import { useSelectedAgencyPrefixMaxMagnitude } from "../../hooks/useSelectedAgencyPrefixMaxMagnitude";
function ProductNumberAssign() {
    var _this = this;
    var _a, _b, _c, _d, _e, _f;
    var history = useHistory();
    var productId = useParams().productId;
    var formatMessage = useIntl().formatMessage;
    var _g = usePermissions(), isAgencyWorker = _g.isAgencyWorker, isSuperUser = _g.isSuperUser, isPublisherRoleOnly = _g.isPublisherRoleOnly;
    var canEdit = isAgencyWorker || isSuperUser || isPublisherRoleOnly;
    var _h = useState(""), publisherQuery = _h[0], setPublisherQuery = _h[1];
    var _j = useState(""), internationalPrefixQuery = _j[0], setInternationalPrefixQuery = _j[1];
    var formHook = useProductNumberAssignForm(canEdit, undefined, null, setInternationalPrefixQuery, setPublisherQuery, internationalPrefixQuery, publisherQuery);
    var control = formHook.control, errors = formHook.errors, handleSubmit = formHook.handleSubmit, setValue = formHook.setValue, selectedPublisherId = formHook.selectedPublisherId, selectedInternationalPrefixId = formHook.selectedInternationalPrefixId, selectedAgencyPrefixId = formHook.selectedAgencyPrefixId, selectedPublisherPrefixId = formHook.selectedPublisherPrefixId, handleInternationalPrefixInput = formHook.handleInternationalPrefixInput, handleInternationalPrefixSelection = formHook.handleInternationalPrefixSelection, handlePublisherInput = formHook.handlePublisherInput, handlePublisherSelection = formHook.handlePublisherSelection, handleAgencyPrefixSelection = formHook.handleAgencyPrefixSelection, handlePublisherPrefixSelection = formHook.handlePublisherPrefixSelection, handleMagnitudeChange = formHook.handleMagnitudeChange;
    var _k = useProductNumberAssignData(productId, selectedPublisherId, selectedInternationalPrefixId, selectedAgencyPrefixId, publisherQuery, internationalPrefixQuery), assignmentData = _k.assignmentData, isAssignmentLoading = _k.isAssignmentLoading, isAssignmentError = _k.isAssignmentError, assignmentError = _k.assignmentError, assignBlockedReason = _k.assignBlockedReason, publisherId = _k.publisherId, publisherIdFromAssignment = _k.publisherIdFromAssignment, agency = _k.agency, isOneOffPublisher = _k.isOneOffPublisher, publisherDetail = _k.publisherDetail, previewResponse = _k.previewResponse, setPreviewResponse = _k.setPreviewResponse, publishers = _k.publishers, publisherLoading = _k.publisherLoading, publisherPrefixes = _k.publisherPrefixes, publisherPrefixLoading = _k.publisherPrefixLoading, allInternationalPrefixes = _k.allInternationalPrefixes, internationalPrefixes = _k.internationalPrefixes, internationalPrefixLoading = _k.internationalPrefixLoading, agencyPrefixes = _k.agencyPrefixes, agencyPrefixLoading = _k.agencyPrefixLoading;
    useEffect(function () {
        if (publisherIdFromAssignment) {
            setValue("publisherId", publisherIdFromAssignment);
        }
    }, [publisherIdFromAssignment, setValue]);
    useEffect(function () {
        if (selectedPublisherId &&
            selectedPublisherId !== publisherIdFromAssignment) {
            setPreviewResponse(null);
            setValue("internationalPrefixId", "");
            setValue("agencyPrefixId", "");
            setValue("publisherPrefixId", "");
        }
    }, [
        selectedPublisherId,
        publisherIdFromAssignment,
        setPreviewResponse,
        setValue,
    ]);
    useEffect(function () {
        var _a, _b, _c;
        if (previewResponse) {
            if (((_a = previewResponse.internationalPrefix) === null || _a === void 0 ? void 0 : _a.id) &&
                !selectedInternationalPrefixId) {
                setValue("internationalPrefixId", previewResponse.internationalPrefix.id);
            }
            if (((_b = previewResponse.agencyPrefix) === null || _b === void 0 ? void 0 : _b.id) && !selectedAgencyPrefixId) {
                setValue("agencyPrefixId", previewResponse.agencyPrefix.id);
            }
            if (previewResponse.createNewPublisherPrefix &&
                ((_c = previewResponse.publisherPrefix) === null || _c === void 0 ? void 0 : _c.id) &&
                !selectedPublisherPrefixId) {
                setValue("publisherPrefixId", previewResponse.publisherPrefix.id);
            }
        }
    }, [
        previewResponse,
        selectedInternationalPrefixId,
        selectedAgencyPrefixId,
        selectedPublisherPrefixId,
        setValue,
    ]);
    useEffect(function () {
        if (allInternationalPrefixes.length === 1 &&
            allInternationalPrefixes[0].id &&
            !selectedInternationalPrefixId &&
            !(previewResponse === null || previewResponse === void 0 ? void 0 : previewResponse.internationalPrefix)) {
            setValue("internationalPrefixId", allInternationalPrefixes[0].id, {
                shouldValidate: true,
            });
        }
    }, [
        allInternationalPrefixes,
        selectedInternationalPrefixId,
        previewResponse,
        setValue,
    ]);
    useEffect(function () {
        if (agencyPrefixes.length === 1 &&
            agencyPrefixes[0].id &&
            !selectedAgencyPrefixId &&
            !(previewResponse === null || previewResponse === void 0 ? void 0 : previewResponse.agencyPrefix)) {
            setValue("agencyPrefixId", agencyPrefixes[0].id, {
                shouldValidate: true,
            });
        }
    }, [agencyPrefixes, selectedAgencyPrefixId, previewResponse, setValue]);
    var _l = useModal(), isOpen = _l.isOpen, message = _l.message, action = _l.action, closeModal = _l.closeModal, openModal = _l.openModal;
    var _m = useSuccessModal(), isSuccessOpen = _m.isOpen, successMessage = _m.message, successAction = _m.action, closeSuccessModal = _m.closeSuccessModal, openSuccessModal = _m.openSuccessModal;
    // FSD PP20: the block size of a new prefix is capped by the publisher's production (always 1000 for
    // agency workers). The cap belongs to the agency prefix selected right now, so it is asked for that
    // selection; only the allowed sizes are offered and the smallest one is preselected.
    var selectionDecisionEnabled = !!selectedAgencyPrefixId && !publisherPrefixLoading && !isOneOffPublisher;
    var _o = useSelectedAgencyPrefixMaxMagnitude({
        productId: productId,
        publisherId: publisherId,
        agencyPrefixId: selectedAgencyPrefixId,
        reservedProductNumberId: (_a = previewResponse === null || previewResponse === void 0 ? void 0 : previewResponse.productNumber) === null || _a === void 0 ? void 0 : _a.id,
        enabled: selectionDecisionEnabled,
        isPublisherRoleOnly: isPublisherRoleOnly,
    }), maxMagnitude = _o.maxMagnitude, allowedMagnitudes = _o.allowedMagnitudes, selectionPreview = _o.selectionPreview, isMaxMagnitudeLoading = _o.isLoading;
    var decisionPending = selectionDecisionEnabled && isMaxMagnitudeLoading;
    var usablePublisherPrefixes = useMemo(function () {
        return decisionPending
            ? []
            : filterUsablePublisherPrefixes(publisherPrefixes, selectionPreview);
    }, [decisionPending, publisherPrefixes, selectionPreview]);
    var newPrefixNeeded = !decisionPending &&
        isNewPrefixNeeded({
            selectionPreview: selectionPreview,
            publisherPrefixCount: usablePublisherPrefixes.length,
        });
    var automaticPrefixSize = isOneOffPublisher || !!(selectionPreview === null || selectionPreview === void 0 ? void 0 : selectionPreview.newPrefixSizeAutomatic);
    var showMagnitudeChoice = selectionDecisionEnabled && newPrefixNeeded && !automaticPrefixSize;
    var selectionNoticeMessageId = selectionDecisionEnabled
        ? resolveSelectionNoticeMessageId(selectionPreview)
        : resolvePreviewNoNumberNoticeMessageId({
            preview: assignmentData,
            selectedPublisherId: selectedPublisherId,
            selectedAgencyPrefixId: selectedAgencyPrefixId,
            loading: publisherPrefixLoading,
        });
    useEffect(function () {
        if (newPrefixNeeded && selectedPublisherPrefixId) {
            setValue("publisherPrefixId", "");
        }
    }, [newPrefixNeeded, selectedPublisherPrefixId, setValue]);
    useEffect(function () {
        if (usablePublisherPrefixes.length === 1 &&
            usablePublisherPrefixes[0].id &&
            !selectedPublisherPrefixId &&
            !(previewResponse === null || previewResponse === void 0 ? void 0 : previewResponse.publisherPrefix) &&
            !isMaxMagnitudeLoading &&
            !newPrefixNeeded) {
            setValue("publisherPrefixId", usablePublisherPrefixes[0].id, {
                shouldValidate: true,
            });
        }
    }, [
        usablePublisherPrefixes,
        selectedPublisherPrefixId,
        previewResponse,
        isMaxMagnitudeLoading,
        newPrefixNeeded,
        setValue,
    ]);
    var allowedMagnitudeOptions = getAllowedMagnitudeOptions(maxMagnitude, allowedMagnitudes);
    var defaultMagnitude = resolveEffectiveMagnitude(null, maxMagnitude, allowedMagnitudes);
    useEffect(function () {
        setValue("magnitude", defaultMagnitude);
    }, [defaultMagnitude, setValue]);
    var _p = useProductNumberAssignActions(productId, publisherId, previewResponse, setPreviewResponse, openModal, openSuccessModal, newPrefixNeeded), showConfirmation = _p.showConfirmation, submitAssignment = _p.onSubmit, handleConfirmSubmit = _p.handleConfirmSubmit, handleCancelConfirmation = _p.handleCancelConfirmation;
    // Never submit a block size beyond the cap of the current selection (e.g. the form default).
    var onSubmit = function (formData) {
        return submitAssignment(__assign(__assign({}, formData), { magnitude: automaticPrefixSize
                ? 0
                : resolveEffectiveMagnitude(formData.magnitude, maxMagnitude, allowedMagnitudes) }));
    };
    var _q = useProductNumberAssignOptions(internationalPrefixes, allInternationalPrefixes, selectedInternationalPrefixId, agencyPrefixes, selectedAgencyPrefixId, usablePublisherPrefixes, selectedPublisherPrefixId), internationalPrefixOptions = _q.internationalPrefixOptions, agencyPrefixOptions = _q.agencyPrefixOptions, publisherPrefixOptions = _q.publisherPrefixOptions;
    var _r = useAccordion({ general: true }), accordionStatus = _r.accordionStatus, toggleAccordion = _r.toggleAccordion;
    var handleBackToProducts = function () { return history.push(navigation.products.path); };
    var paneTitle = formatMessage({
        id: "ui-br-agency.product-number.assign.pane.title",
    });
    // Loading: show a message instead of a blank pane.
    if (isAssignmentLoading) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: paneTitle },
                React.createElement(FormattedMessage, { id: "ui-br-agency.loading" }))));
    }
    // Load failure (e.g. product not found, or a legacy 422): never a blank/white page —
    // show a localized message and a "Zpět" button (mirrors ProductDetailPage).
    if (isAssignmentError || !assignmentData) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: paneTitle },
                React.createElement("p", null, (assignmentError === null || assignmentError === void 0 ? void 0 : assignmentError.message) ||
                    formatMessage({
                        id: "ui-br-agency.product-number.assign.error.loadFailed",
                    })),
                React.createElement(Button, { buttonStyle: "primary", onClick: handleBackToProducts },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.back" })))));
    }
    // Assignment is blocked by a precondition (the backend returned 200 with a reason):
    // explain why, in Czech, show the existing number when the product already has one,
    // and offer only a way back — saving is intentionally not possible.
    var blockedMessageId = getAssignBlockedReasonMessageId(assignBlockedReason);
    if (blockedMessageId) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: paneTitle },
                React.createElement(MessageBanner, { type: "warning" }, formatMessage({ id: blockedMessageId })),
                assignmentData.assignedValue && (React.createElement("p", null,
                    React.createElement("strong", null, formatMessage({
                        id: "ui-br-agency.product-number.assign.modal.confirm.assignedValue",
                    })),
                    " ",
                    assignmentData.assignedValue)),
                React.createElement(Button, { buttonStyle: "primary", onClick: handleBackToProducts },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.back" })))));
    }
    var agencyLabel = formatMessage({ id: getAgencyLabelMessageId(agency) });
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                id: "ui-br-agency.product-number.assign.pane.title",
            }), footer: React.createElement(PaneFooter, { renderStart: canEdit ? (React.createElement(Button, { type: "submit", buttonStyle: "primary", marginBottom0: true, disabled: !!selectionNoticeMessageId || decisionPending, onClick: handleSubmit(onSubmit) },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.save" }))) : null, renderEnd: React.createElement(Button, { buttonStyle: "default", onClick: function () { return history.push(navigation.products.path); }, marginBottom0: true },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.cancel" })) }) },
            React.createElement(ErrorModal, { open: isOpen, label: formatMessage({
                    id: "ui-br-agency.product-number.assign.modal.error.label",
                }), content: message, onClose: function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                closeModal();
                                if (!action) return [3 /*break*/, 2];
                                return [4 /*yield*/, action()];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2: return [2 /*return*/];
                        }
                    });
                }); } }),
            React.createElement(Modal, { open: isSuccessOpen, label: formatMessage({
                    id: "ui-br-agency.product-number.assign.modal.success.label",
                }), footer: React.createElement(Button, { buttonStyle: "primary", onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    closeSuccessModal();
                                    if (!successAction) return [3 /*break*/, 2];
                                    return [4 /*yield*/, successAction()];
                                case 1:
                                    _a.sent();
                                    _a.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); } },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.ok" })) }, successMessage),
            React.createElement(ConfirmationModal, { open: showConfirmation, heading: formatMessage({
                    id: "ui-br-agency.product-number.assign.modal.confirm.heading",
                }), message: previewResponse ? (React.createElement("div", null,
                    React.createElement("p", null,
                        React.createElement("strong", null, formatMessage({
                            id: "ui-br-agency.product-number.assign.modal.confirm.publisher",
                        })),
                        " ",
                        previewResponse.publisherName || "-"),
                    React.createElement("p", null,
                        React.createElement("strong", null, formatMessage({
                            id: "ui-br-agency.product-number.assign.modal.confirm.title",
                        })),
                        " ",
                        previewResponse.title || "-"),
                    React.createElement("p", null,
                        React.createElement("strong", null, formatMessage({
                            id: "ui-br-agency.product-number.assign.modal.confirm.product",
                        })),
                        " ",
                        previewResponse.product || "-"),
                    React.createElement("p", null,
                        React.createElement("strong", null, formatMessage({
                            id: "ui-br-agency.product-number.assign.modal.confirm.agency",
                        })),
                        " ",
                        ((_c = (_b = previewResponse.agencyPrefix) === null || _b === void 0 ? void 0 : _b.internationalPrefix) === null || _c === void 0 ? void 0 : _c.agency) ||
                            "-"),
                    React.createElement("p", null,
                        React.createElement("strong", null, formatMessage({
                            id: "ui-br-agency.product-number.assign.modal.confirm.internationalPrefix",
                        })),
                        " ",
                        ((_d = previewResponse.internationalPrefix) === null || _d === void 0 ? void 0 : _d.value) || "-"),
                    React.createElement("p", null,
                        React.createElement("strong", null, formatMessage({
                            id: "ui-br-agency.product-number.assign.modal.confirm.agencyPrefix",
                        })),
                        " ",
                        ((_e = previewResponse.agencyPrefix) === null || _e === void 0 ? void 0 : _e.value) || "-"),
                    React.createElement("p", null,
                        React.createElement("strong", null, formatMessage({
                            id: "ui-br-agency.product-number.assign.modal.confirm.publisherPrefix",
                        })),
                        " ",
                        ((_f = previewResponse.publisherPrefix) === null || _f === void 0 ? void 0 : _f.value) || "-"),
                    previewResponse.createNewPublisherPrefix ? (React.createElement("p", null, formatMessage({
                        id: "ui-br-agency.product-number.assign.modal.confirm.newPrefix",
                    }))) : (React.createElement("p", null,
                        React.createElement("strong", null, formatMessage({
                            id: "ui-br-agency.product-number.assign.modal.confirm.assignedValue",
                        })),
                        " ",
                        previewResponse.assignedValue || "-")),
                    previewResponse.agency &&
                        getActiveRegistrations(publisherDetail).length > 0 &&
                        !getActiveRegistrationForAgency(publisherDetail, previewResponse.agency) && (React.createElement(MessageBanner, { type: "warning" }, formatMessage({
                        id: "ui-br-agency.product-number.assign.modal.confirm.specialPrefix.warning",
                    }))),
                    React.createElement("p", null, formatMessage({
                        id: "ui-br-agency.product-number.assign.modal.confirm.question",
                    })))) : null, onConfirm: handleConfirmSubmit, onCancel: handleCancelConfirmation, confirmLabel: formatMessage({
                    id: "ui-br-agency.product-number.assign.modal.confirm.button.confirm",
                }), cancelLabel: formatMessage({
                    id: "ui-br-agency.product-number.assign.modal.confirm.button.cancel",
                }) }),
            React.createElement("form", null,
                React.createElement(AccordionSet, null,
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-agency.product-number.accordions.label.general",
                        }), open: accordionStatus.general, onToggle: function () { return toggleAccordion("general"); } },
                        (isAgencyWorker || isSuperUser) && (React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { name: "publisherId", control: control, render: function (_a) {
                                        var _b, _c;
                                        var field = _a.field;
                                        return (React.createElement(RecekSelection, { labelId: "ui-br-agency.product-number.assign.field.label.publisher", placeholder: formatMessage({
                                                id: "ui-br-agency.product-number.assign.field.placeholder.publisher",
                                            }), value: (_b = field.value) !== null && _b !== void 0 ? _b : "", onChange: function (publisherId) {
                                                return handlePublisherSelection(publisherId, publishers);
                                            }, onFilter: handlePublisherInput, dataOptions: publishers && publishers.length > 0
                                                ? publishers.map(function (publisher) {
                                                    var _a, _b;
                                                    return ({
                                                        value: (_a = publisher.id) !== null && _a !== void 0 ? _a : "",
                                                        label: (_b = publisher.name) !== null && _b !== void 0 ? _b : "",
                                                    });
                                                })
                                                : field.value && (assignmentData === null || assignmentData === void 0 ? void 0 : assignmentData.publisherName)
                                                    ? [
                                                        {
                                                            value: field.value,
                                                            label: assignmentData.publisherName,
                                                        },
                                                    ]
                                                    : [], loading: publisherLoading, error: (_c = errors.publisherId) === null || _c === void 0 ? void 0 : _c.message, asyncFilter: true, required: true }));
                                    } })))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(RecekTextField, { labelId: "ui-br-agency.product-number.assign.field.label.title", value: assignmentData.title || "", disabled: true }))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(RecekTextField, { labelId: "ui-br-agency.product-number.assign.field.label.product", value: assignmentData.product || "", disabled: true }))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(RecekTextField, { labelId: "ui-br-agency.product-number.assign.field.label.agency", value: agencyLabel, disabled: true }))),
                        (previewResponse === null || previewResponse === void 0 ? void 0 : previewResponse.internationalPrefix) ? (React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(RecekTextField, { labelId: "ui-br-agency.product-number.assign.field.label.internationalPrefix", value: previewResponse.internationalPrefix.value || "", disabled: true })))) : (React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { name: "internationalPrefixId", control: control, render: function (_a) {
                                        var _b, _c;
                                        var field = _a.field;
                                        return (React.createElement(RecekSelection, { labelId: "ui-br-agency.product-number.assign.field.label.internationalPrefix", placeholder: formatMessage({
                                                id: "ui-br-agency.product-number.assign.field.placeholder.internationalPrefix",
                                            }), value: (_b = field.value) !== null && _b !== void 0 ? _b : "", onChange: handleInternationalPrefixSelection, onFilter: handleInternationalPrefixInput, dataOptions: internationalPrefixOptions, loading: internationalPrefixLoading, error: (_c = errors.internationalPrefixId) === null || _c === void 0 ? void 0 : _c.message, asyncFilter: true, required: true, disabled: !canEdit || allInternationalPrefixes.length === 1 }));
                                    } })))),
                        (previewResponse === null || previewResponse === void 0 ? void 0 : previewResponse.agencyPrefix) ? (React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(RecekTextField, { labelId: "ui-br-agency.product-number.assign.field.label.agencyPrefix", value: previewResponse.agencyPrefix.value || "", disabled: true })))) : selectedInternationalPrefixId ? (React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { name: "agencyPrefixId", control: control, render: function (_a) {
                                        var _b, _c;
                                        var field = _a.field;
                                        return (React.createElement(RecekSelection, { labelId: "ui-br-agency.product-number.assign.field.label.agencyPrefix", placeholder: formatMessage({
                                                id: "ui-br-agency.product-number.assign.field.placeholder.agencyPrefix",
                                            }), value: (_b = field.value) !== null && _b !== void 0 ? _b : "", onChange: handleAgencyPrefixSelection, dataOptions: agencyPrefixOptions, loading: agencyPrefixLoading, error: (_c = errors.agencyPrefixId) === null || _c === void 0 ? void 0 : _c.message, required: true, disabled: !canEdit || agencyPrefixes.length === 1 }));
                                    } })))) : null,
                        (previewResponse === null || previewResponse === void 0 ? void 0 : previewResponse.publisherPrefix) ? (React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(RecekTextField, { labelId: "ui-br-agency.product-number.assign.field.label.publisherPrefix", value: previewResponse.publisherPrefix.value || "", disabled: true })))) : selectedAgencyPrefixId &&
                            usablePublisherPrefixes.length > 0 &&
                            !newPrefixNeeded ? (React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { name: "publisherPrefixId", control: control, render: function (_a) {
                                        var _b, _c;
                                        var field = _a.field;
                                        return (React.createElement(RecekSelection, { labelId: "ui-br-agency.product-number.assign.field.label.publisherPrefix", placeholder: formatMessage({
                                                id: "ui-br-agency.product-number.assign.field.placeholder.publisherPrefix",
                                            }), value: (_b = field.value) !== null && _b !== void 0 ? _b : "", onChange: handlePublisherPrefixSelection, dataOptions: publisherPrefixOptions, loading: publisherPrefixLoading, error: (_c = errors.publisherPrefixId) === null || _c === void 0 ? void 0 : _c.message, required: true, disabled: !canEdit || usablePublisherPrefixes.length === 1 }));
                                    } })))) : null,
                        selectionNoticeMessageId && (React.createElement(MessageBanner, { type: "warning" }, formatMessage({ id: selectionNoticeMessageId }))),
                        showMagnitudeChoice && (React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement("fieldset", null,
                                    React.createElement("legend", null,
                                        formatMessage({
                                            id: "ui-br-agency.product-number.assign.field.label.magnitude",
                                        }),
                                        " ",
                                        "*"),
                                    React.createElement(Controller, { name: "magnitude", control: control, render: function (_a) {
                                            var field = _a.field;
                                            return isMaxMagnitudeLoading ? (React.createElement(Loading, null)) : offersOnlySmallestMagnitude(allowedMagnitudeOptions) ? (
                                            // FSD PP20: only the smallest block is allowed — no choice to make.
                                            React.createElement("p", null,
                                                React.createElement(FormattedMessage, { id: resolveNewPrefixChoiceMessageIds({
                                                        replacesUsedUpPrefix: selectionPreview === null || selectionPreview === void 0 ? void 0 : selectionPreview.replacesUsedUpPrefix,
                                                    }).onlyTenId }))) : (React.createElement(React.Fragment, null, allowedMagnitudeOptions.map(function (opt) { return (React.createElement(RadioButton, { key: opt.value, label: formatMessage({ id: opt.labelId }, opt.labelValues), value: String(opt.value), checked: field.value === opt.value, onChange: function () {
                                                    return handleMagnitudeChange(opt.value);
                                                }, disabled: !canEdit })); })));
                                        } }),
                                    errors.magnitude && (React.createElement("div", { style: { color: "red" } }, errors.magnitude.message)))))),
                        (previewResponse === null || previewResponse === void 0 ? void 0 : previewResponse.assignedValue) && (React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(RecekTextField, { labelId: "ui-br-agency.product-number.assign.field.label.value", value: previewResponse.assignedValue, disabled: true }))))))))));
}
export default ProductNumberAssign;
